import React, { ReactNode, useMemo } from 'react';
import { Stack } from 'new/elements/Stack';
import Typography from 'new/elements/Typography';
import { FCFormPageType, useForm } from 'new/elements/Form/useForm';
import { NexlaContextualMenu } from 'new/components/NexlaContextualMenu/NexlaContextualMenu';
import { Box } from '@mui/material';
import { FormHeaderActions, StepsForm } from 'new/elements/Form/components';

import classes from './Header.module.scss';

interface FlowHeaderProps {
  rightView?: ReactNode;
  leftView?: ReactNode;
  title: ReactNode | string;
  description?: string;
  hideLogo?: boolean;
  overrideStepsSection?: ReactNode; // Used at CreateDirectFlow.tsx
  hideContextualMenu?: boolean;
}

export const Header: FCFormPageType<FlowHeaderProps> = (props) => {
  const {
    title,
    description = '',
    rightView,
    hideContextualMenu = false,
    overrideStepsSection: overrideFormHeaderActions = null,
  } = props;

  const descriptionElement = useMemo(() => {
    return !!description && <Typography variant="body3">{description}</Typography>;
  }, [description]);

  const headerActionsElement = useMemo(() => {
    return overrideFormHeaderActions || <FormHeaderActions />;
  }, [overrideFormHeaderActions]);

  return (
    <header aria-label="form-header-inner-container" className={classes.header}>
      <div className={classes.container}>
        <Stack direction="row" alignItems="center" gap="8px">
          {hideContextualMenu ? null : <NexlaContextualMenu />}

          <Stack direction="row" alignItems="center" gap="24px">
            <Stack>
              <Typography className={classes.name} variant="bodyLarge">
                {title}
              </Typography>

              {descriptionElement}
            </Stack>

            {rightView}
          </Stack>
        </Stack>

        <Box>
          <StepsFormWrapper />
        </Box>

        {headerActionsElement}
      </div>
    </header>
  );
};

Header.type = 'FormHeader';
Header.displayName = 'FormHeader';

function StepsFormWrapper() {
  const { activePage, steps } = useForm();
  return <StepsForm activePage={activePage} steps={steps as any} />;
}
